'use strict';

const COLORS = {
    GRAY: 'gray',
    LIGHT: 'light',
    DARK: 'dark',
    GREEN: 'green',
    BLUE: 'blue',
    ORANGE: 'orange',
    VIOLET: 'violet',
    RED: 'red',
};

exports.COLORS = COLORS;
//# sourceMappingURL=colors.js.map
